module.exports = __webpack_public_path__ + "static/media/digi-doodle.974d49b2.png";